export const texts = {
  genderSuffix: {
    de: 'm|w|d',
    en: 'm|f|d'
  },
  tabs: {
    base: { de: 'Übersicht', en: 'Overview' },
    analysis: { de: 'Analyse', en: 'Analysis' },
    outreach: { de: 'Ansprache', en: 'Outreach' },
    applications: { de: 'Bewerbungen', en: 'Applications' }
  },
  progress: {
    analysis: { de: 'Analyse', en: 'Analysis' },
    talents: { de: 'Talente', en: 'Talents' },
    outreach: { de: 'Ansprache', en: 'Outreach' },
    applications: { de: 'Bewerbungen', en: 'Applications' }
  },
  startSourcing: {
    de: 'Starten',
    en: 'Start'
  },
  startedSourcing: {
    de: 'Gestartet',
    en: 'Started'
  },
  completed: {
    de: 'Abgeschlossen',
    en: 'completed'
  }
};
